export const BAC_LANGUAGE = {
  partner_b2b_heading_partner_organization: "Partner Organization",
  partner_b2b_listing_name: "Name",
  partner_b2b_listing_type: "Type",
  partner_b2b_listing_child_organization: "Child Organization",

  partner_b2b_tab_parent_organization: "Parent Organization",
  partner_b2b_tab_child_organization: "Child Organization",
  partner_b2b_tab_policy_details: "Policy Details",
  partner_b2b_tab_vehicle_onboarding: "Vehicles",
  partner_b2b_tab_point_of_contact: "Point of Contact",
  partner_b2b_tab_agent: "Account Manager",
  partner_b2b_tab_member_onboarding: "Members",

  bac_partner_vehicle_onboarding_add_vehicle_details_contact_details: "Contact Details",
  bac_partner_vehicle_onboarding_add_vehicle_details_member_details: "Member Details",
  bac_partner_vehicle_onboarding_add_vehicle_details: "Vehicle Details",
  bac_partner_vehicle_onboarding_vehicle_details_title: "Vehicle Details",
  bac_partner_vehicle_onboarding_add_vehicle_details_registration_no: "Registration Number",
  bac_partner_vehicle_onboarding_view_vehicle_details_registration_no: "Registration No.",
  bac_partner_vehicle_onboarding_add_vehicle_details_registration_no_length_error: "Registration Number must be smaller than 10 characters",
  bac_partner_vehicle_onboarding_add_vehicle_details_registration_no_required_error: "Registration Number is required",
  bac_partner_vehicle_onboarding_add_vehicle_details_member: "Member Name",
  bac_partner_vehicle_onboarding_add_vehicle_chassis_no: "Chassis Number",
  bac_partner_vehicle_onboarding_view_vehicle_chassis_no: "Chassis No.",
  bac_partner_vehicle_onboarding_add_vehicle_details_chassis_no_length_error: "Chassis Number must be smaller than 50 characters",

  bac_partner_vehicle_onboarding_add_vehicle_engine_no: "Engine Number",
  bac_partner_vehicle_onboarding_view_vehicle_engine_no: "Engine No.",
  bac_partner_vehicle_onboarding_add_vehicle_details_engine_no_length_error: "Chassis Number must be smaller than 50 characters",

  bac_partner_vehicle_onboarding_add_vehicle_details_make: "Make",
  bac_partner_vehicle_onboarding_add_vehicle_details_make_error: "Make is required",

  bac_partner_vehicle_onboarding_add_vehicle_details_model: "Model",
  bac_partner_vehicle_onboarding_add_vehicle_details_model_error: "Model is required",

  bac_partner_vehicle_onboarding_add_vehicle_details_variant: "Variant",
  bac_partner_vehicle_onboarding_add_vehicle_details_variant_error: "Variant is required",

  bac_partner_vehicle_onboarding_add_vehicle_details_year: "Year",
  bac_partner_vehicle_onboarding_add_vehicle_details_year_error: "Year is required",

  bac_partner_vehicle_onboarding_add_vehicle_details_value: "Value",
  bac_partner_vehicle_onboarding_add_vehicle_organization: "Organization",
  bac_partner_vehicle_onboarding_add_vehicle_value_required_error: "Value is required",
  bac_partner_vehicle_onboarding_add_vehicle_organization_required_error: "Organization is required",
  bac_partner_vehicle_onboarding_add_member_details_name_length_error: "Member Name must not be greater than 100 characters",
  bac_partner_vehicle_onboarding_add_member_details_id_length_error: "Member Id must not be greater than 100 characters",
  bac_partner_vehicle_onboarding_add_member_details_alpha_numeric_error: "Member Id must not contain any special character",
  bac_partner_vehicle_onboarding_add_member_details_id_required_error: "Member Id is required",

  bac_partner_vehicle_onboarding_add_member_details_contact_no: "Contact No.",
  bac_partner_vehicle_onboarding_add_member_details_contact_no_error: "Contact number is required",
  bac_partner_vehicle_onboarding_add_member_details_email_address: "Email Address",
  bac_partner_vehicle_onboarding_add_member_details_email_address_error: "Email Address is required",
  bac_partner_vehicle_onboarding_add_member_details_email_address_validation_error: "Invalid email address",
  bac_partner_vehicle_onboarding_add_member_details_takaful_provider: "Takaful Provider",
  bac_partner_vehicle_onboarding_add_member_details_policy: "Policy",
  bac_partner_vehicle_onboarding_add_member_details_plan: "Plan",
  bac_partner_vehicle_onboarding_add_vehicle_details_policy_details: "Policy Details",
  bac_partner_vehicle_onboarding_add_vehicle_details_organization_details: "Organization Details",
  bac_partner_vehicle_onboarding_add_vehicle_details_takaful_service_provider_error: "Takaful / Service Provider is required",

  bac_partner_vehicle_onboarding_add_vehicle_details_takaful_service_provider: "Takaful / Service Provider",

  bac_partner_vehicle_onboarding_add_vehicle_details_plan_name: "Plan Name",
  bac_partner_vehicle_onboarding_add_vehicle_details_plan_name_error: "Plan Name is required",
  bac_partner_vehicle_onboarding_add_vehicle_details_policy_number: "Policy Number",
  bac_partner_vehicle_onboarding_add_vehicle_details_policy_number_error: "Policy Number is required",
  bac_partner_vehicle_onboarding_add_vehicle_details_member_id: "Member ID",

  bac_partner_vehicle_onboarding_add_vehicle_details_cnic: "CNIC",
  bac_partner_vehicle_onboarding_add_vehicle_details_cnic_number: "CNIC Number",
  bac_partner_vehicle_onboarding_add_vehicle_details_cnic_error: "CNIC is required",
  bac_partner_vehicle_onboarding_add_vehicle_details_cnic_length_error: "CNIC Number should be 13 digits only",
  bac_partner_vehicle_onboarding_add_vehicle_details_cnic_validation_error: "Incorrect format i.e 12345-4567896-6",
  bac_partner_vehicle_onboarding_add_vehicle_details_cnic_number_placeholder: "12345-4567896-6",

  partner_b2b_policy_details_heading: "Policy Details",
  partner_b2b_policy_details_listing_takaful_service_provider: "Takaful / Service Provider",
  partner_b2b_policy_details_listing_provider_type: "Provider Type",
  partner_b2b_policy_details_listing_policy_number: "Policy Number",
  partner_b2b_policy_details_listing_organization: "Organization",
  partner_b2b_policy_details_listing_effective_date: "Effective Date",
  partner_b2b_policy_details_listing_expiry_date: "Expiry Date",
  partner_b2b_policy_details_listing_coverage_type: "Coverage Type",
  partner_b2b_policy_details_listing_premium: "Premium",
  partner_b2b_policy_details_add_heading: "Add Policy Details",
  partner_b2b_policy_details_edit_heading: "Edit Policy Details",

  partner_b2b_policy_details_add_takaful_service_provider: "Takaful / Service Provider",
  partner_b2b_policy_details_add_provider_type_error: "Takaful / Service Provider type is required",
  partner_b2b_policy_details_add_provider_type: "Provider Type",
  partner_b2b_policy_details_add_provider_type_required: "Provider type is required",
  partner_b2b_policy_details_add_policy_number: "Policy Number",
  partner_b2b_policy_details_add_policy_number_error: "Policy number is required",
  partner_b2b_policy_details_add_policy_number_length_error: "Policy number must be smaller than 50 characters",
  partner_b2b_policy_details_add_organization: "Organization",
  partner_b2b_policy_details_add_organization_error: "Organization is required",
  partner_b2b_policy_details_add_effective_date: "Effective Date",
  partner_b2b_policy_details_add_effective_date_error: "Effective date is required",
  partner_b2b_policy_details_add_expiry_date: "Expiry Date",
  partner_b2b_policy_details_add_expiry_date_error: "Expiry date is required",
  partner_b2b_policy_details_add_date_of_expiry_error: "Expiry date is greater then Effective date",

  partner_b2b_policy_details_add_coverage_type: "Coverage Type",
  partner_b2b_policy_details_add_coverage_type_error: "Coverage type is required",
  partner_b2b_policy_details_add_premium: "Premium",
  partner_b2b_policy_coverage_type: "Coverage Type",
  partner_b2b_policy_coverage_type_required_error: "Coverage type is required ",

  partner_b2b_policy_details_add_premium_error: "Premium is required",
  partner_b2b_policy_details_add_premium_numbers_error: "Premium contain positive numbers only",
  partner_b2b_policy_details_add_service_select_provider_takaful_provider_service_provider: "Takaful / Service Provider",
  partner_b2b_policy_details_add_service_select_provider_takaful_provider: "Takaful Provider",
  partner_b2b_policy_details_add_service_select_provider_service_provider: "Service Provider",
  partner_b2b_policy_details_add_premium_negative_error: "Premium must be greater then zero",
  partner_b2b_policy_details_add_premium_provision_type_required_error: "Premium Type is missing",
  partner_b2b_policy_details_add_premium_decimal_not_allowed_error: "Decimal values are not allowed",
  partner_b2b_policy_details_add_premium_decimal_two_allowed_error: "Only two decimal allowed",
  partner_add_company_name: "Organization Name",
  bac_partner_add_company_name_msg: "Name is required",
  partner_add_company_name_limit: "Name must be smaller than 100 characters",
  bac_partner_organization_type_label: "Organization Type",
  bac_partner_organization_type_required_error: "Organization type is required",
  bac_partner_percentage_waiver_label: "Percentage Waiver",
  bac_partner_percentage_waiver_pattern_error: "It contain number and two decimal only",
  bac_partner_percentage_waiver_required_error: "Percentage waiver is required",
  bac_partner_percentage_waiver_max_error: "Percentage waiver must be less than 100",
  bac_partner_ntn_label: "Ntn No",
  bac_partner_ntn_label_required_error: "Ntn no is required",
  bac_partner_ntn_min_limit_err: "Ntn no must be greater than 7",
  bac_partner_contact_number: "Contact number",
  bac_partner_phone_number: "Phone number",
  bac_partner_address_label: "Address",
  bac_partner_address_required_error: "Address is required",
  bac_partner_address_limit_error: "Address must be smaller than 500 characters",
  bac_partner_bank_name_label: "Bank Name",
  bac_partner_bank_name_limit_error: "Bank name must be smaller than 50 characters",
  bac_partner_bank_name_pattern_error: "Bank name should be alphabet only",
  bac_partner_bank_account_title: "Bank Account Title",
  bac_partner_bank_account_title_pattern_error: "Bank account title should be alphabet only",
  bac_partner_bank_account_title_limit_error: "Bank account title must be smaller than 50 characters",
  bac_partner_bank_account_number: "Account Number",
  bac_partner_bank_account_number_limit_error: "Account number must be smaller than 50 characters",
  bac_partner_email_label: "Email",
  bac_partner_bank_account_number_pattern_error: "Account number should be number only",

  bac_partner_organization_details_heading: "Organization Details",
  bac_partner_organization_contact_details: "Contact Details",
  bac_partner_organization_bank_details_heading: "Bank Details",
  bac_partner_child_organization: "Child Organization",
  bac_partner_add_child_organization: " Add Child Organization",
  bac_partner_bank_name_required_err: "Bank name is required",
  bac_partner_bank_title_required_err: "Bank account title is required",
  bac_partner_bank_account_number_required_err: "Account number is required",

  partner_b2b_plan_listing_heading: "Plans",
  partner_b2b_plan_listing_organization: "Organization",
  partner_b2b_plan_listing_organization_name: "Organization Name",

  partner_b2b_plan_listing_type: "Type",
  partner_b2b_plan_listing_sum_assurance_type: "Sum Assurance Type",
  partner_b2b_plan_listing_sum_assurance_value: "Sum Assurance Value",
  partner_b2b_plan_add_info_title: "Information",
  partner_b2b_plans_add_coverage_title: "Coverage",
  partner_b2b_plans_add_coverage_sum_assurance_validation: "Max Limit value cannot be greater than sum assurance value",
  partner_b2b_plans_add_coverage_sum_assurance_validation_not_empty: "Max limit value cannot be empty",
  partner_b2b_plans_add_coverages_title: "Coverages",
  partner_b2b_plans_add_services_title: "Services",
  partner_b2b_plans_add_plan_exclusion_title: "Plan Exclusion",
  partner_b2b_plans_add_plan_info_organization: "Organization",
  partner_b2b_plans_add_plan_info_product_name: "Product Name",
  partner_b2b_plans_add_age_bracket: "Age Bracket",
  partner_b2b_plans_add_sum_assurance_type: "Sum Assurance Type",
  partner_b2b_plans_add_sum_assurance_type_error: "Sum Assurance Type is required",
  partner_b2b_plans_add_enter_value: "Enter Value",
  partner_b2b_plans_add_value: "Value",
  partner_b2b_plans_add_multiple: "Multiple",
  partner_b2b_plans_add_value_error: "Value is required",
  partner_b2b_plans_add_enter_multiple: "Enter Multiple",
  partner_b2b_plans_add_enter_multiple_error: "Enter Multiple is required",

  partner_b2b_plans_add_plan_info_plan_type: "Plan Type",
  partner_b2b_plans_add_plan_info_plan_type_error: "Plan type is required",
  partner_b2b_plans_add_plan_info_product_name_error: "Product name should be alphanumeric",
  partner_b2b_plans_add_plan_info_organization_error: "Organization is required",
  partner_b2b_plans_add_plan_info_plan_name: "Plan Name",
  partner_b2b_plans_add_plan_info_plan_name_error: "Plan name is required",
  partner_b2b_plans_add_plan_info_plan_name_length_error: "Plan name must be equal or smaller than 50 characters",
  partner_b2b_plans_add_plan_info_takaful_provider: "Takaful Provider",
  partner_b2b_plans_add_plan_info_takaful_provider_error: "Takaful provider is required",
  partner_b2b_plans_add_plan_service_title: "Add Service",
  partner_b2b_plans_edit_plan_service_title: "Edit Service",
  partner_b2b_plans_add_plan_services_listing_priority_order: "Priority Order",
  partner_b2b_plans_add_plan_services_listing_service_name: "Service Name",
  partner_b2b_plans_add_plan_services_listing_provider_name: "Provider Name",
  partner_b2b_plans_add_plan_services_listing_sub_services: "Sub-Services",

  partner_b2b_plans_add_service_select_provider: "Select Provider",
  partner_b2b_plans_add_service_select_provider_required_error: "Select Provider is required",
  partner_b2b_plans_add_service_select_provider_takaful_provider: "Takaful Provider",
  partner_b2b_plans_add_service_select_provider_service_provider: "Service Provider",
  partner_b2b_plans_add_service_search_service: "Search Service",
  partner_b2b_plans_add_service_search_service_required_error: "Search Service is required",
  partner_b2b_plans_add_service_service_heading: "Service",
  partner_b2b_plans_add_service_sub_service_heading: "Sub Service",

  partner_b2b_plans_coverage_coverage_type: "Coverage Type",
  partner_b2b_plans_coverage_benefit_value: "Benefit Value",
  partner_b2b_plans_coverage_sub_child: "Sub-Child",
  partner_b2b_plans_add_coverages_coverages: "Select Coverages",
  partner_b2b_plans_add_coverages_coverages_error: "Select Coverages is required",
  partner_b2b_plans_add_coverages_description: "Description",
  partner_b2b_plans_add_coverages_description_error: "Description is required",
  partner_b2b_plans_add_coverages_benefit: "Benefit",
  partner_b2b_plans_add_coverages_benefit_error: "Benefit is required",
  partner_b2b_plans_add_coverages_description_error_max_length: "Description should be under 500 characters",
  partner_b2b_plans_pre_existing_conditions_add_year_description: "Description",
  partner_b2b_plans_pre_existing_conditions_add_year_description_error_max_length: "Description should be under 250 characters",

  partner_b2b_plans_listing_plan_exclusion_title: "Plan Exclusion",
  partner_b2b_plans_listing_plan_exclusion_exclusion_type: "Exclusion Type",
  partner_b2b_plans_listing_plan_exclusion_exclusion_value: "Exclusion Value",
  partner_b2b_plans_listing_plan_exclusion_sub_child: "Sub-Child",
  partner_b2b_plans_add_plan_exclusion_exclusion_error: "Exclusion is required",
  partner_b2b_plans_add_plan_exclusion_description_error_max_length: "Description should be under 500 characters",
  partner_b2b_plans_add_plan_exclusion_exclusion: "Select Exclusion",
  partner_b2b_plans_add_plan_exclusion_description: "Description",
  partner_b2b_plans_add_plan_exclusion_description_error: "Description is required",
  partner_b2b_plans_add_plan_exclusion_benefit: "Benefit",
  partner_b2b_plans_add_plan_exclusion_benefit_error: "Benefit is required",
  bac_partner_point_of_contact_name: "Name",
  bac_partner_point_of_contact_contact_number_grid_title: "Number",
  bac_partner_point_of_contact_contact_number: "Contact number",
  bac_partner_point_of_contact_organization: "Organization",
  bac_partner_point_of_contact_designation: "Designation",
  bac_partner_point_of_contact_address: "Address",
  bac_partner_point_of_contact_line_of_business_grid_title: "Line of Business",
  bac_partner_point_of_contact_line_of_business: "Line of business",
  bac_partner_point_of_contact_add_save: "Add Point of Contact",
  bac_partner_point_of_contact_edit_save: "Edit Point of Contact",

  bac_partner_point_of_contact_heading: "Point of Contact",

  bac_organization_poc_name: "Name",
  bac_organization_poc_name_required_error: "Name is required",
  bac_organization_poc_name_limit_error: "Name must be smaller than 50 characters",
  bac_organization_poc_designation: "Designation",
  bac_organization_poc_designation_required_error: "Designation is required",
  bac_organization_poc_designation_length_error: "Name must be smaller than 50 characters",
  bac_organization_poc_organization: "Organization",
  bac_organization_poc_organization_required_error: "Organization is required",
  bac_agent_name: "Name",
  bac_agent_number: "Contact Number",
  bac_agent_email: "Email",
  bac_agent_organization: "Organization",
  bac_agent_line_of_business: "Line of Business",
  bac_agent: "Account Manager",
  bac_agent_details_heading: "Account Manager Details",

  bac_add_agent: "Add Account Manager",
  bac_edit_agent: "Edit Account Manager",
  bac_add_user_name: "User Name",
  bac_agent_name_required_err: "User Name is required",
  bac_agent_organization_required_err: "Organization is required",

  bac_partner_members_onboarding_title: "Members",
  bac_partner_members_onboarding_view_title: "Member Details",
  bac_partner_members_onboarding_view_sub_heading: "Member ID: ",
  bac_partner_members_onboarding_view_member_name: "Member Name",

  bac_partner_members_onboarding_listing_externalId: "Member ID",
  bac_partner_members_onboarding_listing_name: "Name",
  bac_partner_members_onboarding_listing_cnic: "CNIC",
  bac_partner_members_onboarding_listing_cnic_number: "CNIC Number",

  bac_partner_vehicle_onboarding_title: "Vehicle",
  bac_partner_vehicle_onboarding_listing_registration_number: "Registration No.",
  bac_partner_vehicle_onboarding_listing_chassis_number: "Chassis No.",
  bac_partner_vehicle_onboarding_listing_engine_number: "Engine No.",
  bac_partner_vehicle_onboarding_listing_make: "Make",
  bac_partner_vehicle_onboarding_listing_model: "Model",
  bac_partner_vehicle_onboarding_listing_variant: "Variant",
  bac_partner_vehicle_onboarding_listing_year: "Year",
  bac_partner_vehicle_onboarding_listing_value: "Value",
  bac_partner_vehicle_onboarding_listing_auto_takaful_provider: "Auto Takaful Provider",
  bac_partner_vehicle_onboarding_listing_auto_plan_name: "Auto Plan Name",
  bac_partner_vehicle_onboarding_listing_organization: "Organization",
  bac_partner_vehicle_onboarding_listing_member_id: "Member ID",
  bac_partner_vehicle_onboarding_listing_member_cnic: "Member CNIC",
  bac_partner_vehicle_onboarding_listing_member_name: "Member Name",
  bac_partner_vehicle_onboarding_listing_member_phone_number: "Member Phone Number",
  bac_partner_vehicle_onboarding_listing_member_email: "Member Email Address",
  bac_partner_vehicle_onboarding_listing_member_created: "Created",

  bac_partner_vehicle_onboarding_edit_vehicle: "Edit Vehicle",
  bac_partner_vehicle_onboarding_add_vehicle: "Add Vehicle",

  bac_partner_members_onboarding_listing_organization: "Organization",
  bac_partner_members_onboarding_listing_email: "Email",
  bac_partner_members_onboarding_listing_phone_number: "Phone Number",
  bac_partner_members_onboarding_listing_health_card_number: "Health Card Number",
  bac_partner_members_onboarding_listing_family_certificate_id: "Family Certificate ID",
  bac_partner_members_onboarding_listing_vehicle_registration_number: "Vehicle Registration Number",
  bac_partner_members_onboarding_listing_health_plan_name: "Health Plan Name",
  bac_partner_members_onboarding_listing_family_plan_name: "Family Plan Name",
  bac_partner_members_onboarding_listing_auto_plan_name: "Auto Plan Name",
  bac_partner_members_onboarding_listing_created: "Created By",
  bac_partner_members_onboarding_sum_assurance_type: "Sum Assurance Type",
  bac_partner_members_onboarding_sum_assurance_type_value: "Sum Assurance Type Value",
  bac_partner_members_onboarding_listing_action_upload_list: "Upload List",
  bac_partner_members_onboarding_listing_action_download_list: "Download List",
  bac_partner_members_onboarding_add_member: "Add Member",
  bac_partner_members_onboarding_edit_member: "Edit Member",

  bac_partner_members_onboarding_add_member_details_title: "Member Details",

  bac_partner_members_onboarding_add_member_details_name: "Name",
  bac_partner_members_onboarding_add_member_details_member_id: "Member ID",
  bac_partner_members_onboarding_add_member_details_name_error: "Name is required",
  bac_partner_members_onboarding_add_member_details_name_character_error: "Name should be alphabet only",
  bac_partner_members_onboarding_add_member_details_name_dependency_required_error: "Name is required",
  bac_partner_members_onboarding_add_member_details_name_aplhabate_only_error: "Name should be alphabets only",
  bac_partner_members_onboarding_add_member_details_name_limit_error: "Name must be smaller than 50 characters",
  bac_partner_members_onboarding_add_member_details_name_length_error: "Name must be smaller than 100 characters",

  bac_partner_members_onboarding_add_member_details_gender: "Gender",
  bac_partner_members_onboarding_add_member_details_gender_error: "Gender is required",

  bac_partner_members_onboarding_add_member_details_cnic: "CNIC No.",
  bac_partner_members_onboarding_add_member_details_cnic_error: "CNIC is required",
  bac_partner_members_onboarding_add_member_details_cnic_length_error: "CNIC Number should be 13 digits only",
  bac_partner_members_onboarding_add_member_details_cnic_validation_error: "Incorrect format i.e 12345-4567896-6",

  bac_partner_members_onboarding_add_member_details_cnic_issue_date: "CNIC Issue Date",
  bac_partner_members_onboarding_add_member_details_cnic_issue_date_error: "CNIC issue date is required",
  bac_partner_members_onboarding_add_member_details_cnic_expiry_date: "CNIC Expiry Date",
  bac_partner_members_onboarding_add_member_details_cnic_expiry_date_error: "CNIC expiry date is required",
  bac_partner_members_onboarding_add_member_details_cnic_number_placeholder: "12345-4567896-6",
  bac_partner_members_onboarding_add_member_details_dob: "Date of Birth",
  bac_partner_members_onboarding_add_member_details_dob_error: "Date of birth is required",
  bac_partner_members_onboarding_add_member_details_marital_status: "Marital Status",
  bac_partner_members_onboarding_add_member_details_marital_status_error: "Marital status is required",
  bac_partner_members_onboarding_add_member_details_date_of_marriage: "Date of Marriage",
  bac_partner_members_onboarding_add_member_details_date_of_marriage_error: "Date of marriage is required",
  bac_partner_members_onboarding_add_member_details_date_of_marriage_error_less_than_16_years: "Date of marriage should not be less than 16 years",
  bac_partner_members_onboarding_add_member_details_health_card_no: "Health Card No.",
  bac_partner_members_onboarding_add_member_details_health_card_no_length_error: "Health Card Number must be smaller than 50 characters",
  bac_partner_members_onboarding_add_member_details_health_card_no_validation_error: "Special characters and spaces are not allowed except hyphen",

  bac_partner_members_onboarding_add_member_details_family_certificate_id: "Family Certificate ID",
  bac_partner_members_onboarding_add_member_details_family_certificate_id_length_error: "Family Certificate must be smaller than 50 characters",
  bac_partner_members_onboarding_add_member_details_family_certificate_id_validation_error:
    "Special characters and spaces are not allowed except hyphen",

  bac_partner_members_onboarding_add_member_details_contact_details: "Contact Details",
  bac_partner_members_onboarding_add_member_details_contact_no: "Contact No.",
  bac_partner_members_onboarding_add_member_details_contact_no_error: "Contact number is required",
  bac_partner_members_onboarding_add_member_details_email_address: "Email Address",
  bac_partner_members_onboarding_add_member_details_email_address_error: "Email Address is required",
  bac_partner_members_onboarding_add_member_details_email_address_validation_error: "Invalid email address",
  bac_partner_members_onboarding_add_member_details_organization_details: "Organization Details",
  bac_partner_members_onboarding_add_member_details_organization: "Organization",
  bac_partner_members_onboarding_add_member_details_organization_name: "Organization Name",
  bac_partner_members_onboarding_add_member_details_organization_error: "Organization is required",
  bac_partner_members_onboarding_add_member_details_salary: "Salary",
  bac_partner_members_onboarding_add_member_details_salary_error: "Salary should be number",
  bac_partner_members_onboarding_add_member_details_salary_negative_error: "Negative Values are not allowed",
  bac_partner_members_onboarding_add_member_details_salary_provision_type_required_error: "Salary Type is missing",
  bac_partner_members_onboarding_add_member_details_salary_decimal_not_allowed_error: "Decimal values are not allowed",
  bac_partner_members_onboarding_add_member_details_designation: "Designation",
  bac_partner_members_onboarding_add_member_details_designation_length_error: "Designation must be smaller than 100 characters",

  bac_partner_members_onboarding_add_member_details_vehicle_details: "Vehicle Details",

  bac_partner_members_onboarding_add_member_details_make: "Make",
  bac_partner_members_onboarding_add_member_details_make_error: "Make is required",
  bac_partner_members_onboarding_add_member_details_registration_no: "Registration Number",
  bac_partner_members_onboarding_add_member_details_registration_no_length_error: "Registration Number must be smaller than 10 characters",
  bac_partner_members_onboarding_add_member_details_model: "Model",
  bac_partner_members_onboarding_add_member_details_model_error: "Model is required",
  bac_partner_members_onboarding_add_member_details_variant: "Variant",
  bac_partner_members_onboarding_add_member_details_variant_error: "Variant is required",
  bac_partner_members_onboarding_add_member_details_year: "Year",
  bac_partner_members_onboarding_add_member_details_year_error: "Year is required",
  bac_partner_members_onboarding_add_member_details_value: "Value",
  bac_partner_members_onboarding_add_member_details_chassis_no: "Chassis No.",
  bac_partner_members_onboarding_add_member_details_chassis_no_length_error: "Chassis Number must be smaller than 50 characters",
  bac_partner_members_onboarding_add_member_details_engine_no: "Engine No.",
  bac_partner_members_onboarding_add_member_details_engine_no_length_error: "Engine Number must be smaller than 50 characters",

  bac_partner_members_onboarding_add_member_details_dependent_details: "Dependent Details",
  bac_partner_members_onboarding_add_member_details_relation: "Relation",
  bac_partner_members_onboarding_add_member_details_relation_error: "Relation is required",

  bac_partner_members_onboarding_add_member_details_nominee_details: "Nominee Details",
  bac_partner_members_onboarding_add_member_details_proportyion_of_amount: "Proportion of Amount (in %)",
  bac_partner_members_onboarding_add_member_details_proportion_of_amount_error: "Proportion of Amount is required",
  bac_partner_members_onboarding_add_member_details_proportion_error: "Proportion of Amount can't be greater than 100",

  bac_partner_members_onboarding_view_member_details_coverage: "Coverage",
  bac_partner_members_onboarding_view_member_details_coverage_name: "Coverage Name",
  bac_partner_members_onboarding_view_member_details_sub_coverage: "Sub-Coverage",
  bac_partner_members_onboarding_view_member_details_coverage_type: "Coverage Type",
  bac_partner_members_onboarding_view_member_details_coverage_value: "Coverage Value",

  bac_partner_members_onboarding_add_member_details_policy_details: "Policy Details",
  bac_partner_members_onboarding_add_member_details_takaful_service_provider: "Takaful / Service Provider",
  bac_partner_members_onboarding_add_member_details_takaful_service_provider_error: "Takaful / Service Provider is required",
  bac_partner_members_onboarding_add_member_details_plan_name: "Plan Name",
  bac_partner_member_onboarding_update_bulk_status_error: "Please select at least one member",
  bac_partner_members_onboarding_add_member_details_plan_name_error: "Plan Name is required",
  bac_partner_members_onboarding_add_member_details_policy_number: "Policy Number",
  bac_partner_members_onboarding_add_member_details_policy_number_error: "Policy Number is required",

  bac_partner_members_onboarding_add_value_range_min_maximum_error: "Value must be equal to or less than 9 digits",
  bac_partner_members_onboarding_add_value_range_min_minimum_decimal_error_in_percentage: "Value range must not contain decimal points",
  bac_partner_members_onboarding_add_value_range_min_positive_error: "Value range must be positive",

  bac_partner_member_onboarding_import_document: "Import Document",
  bac_partner_member_onboarding_document_error_found: " errors have been found. ",
  bac_partner_member_onboarding_document_click_here: "Click Here",
  bac_partner_member_onboarding_error_download_file: " to Download the file.",
  bac_partner_member_onboarding_document_required_error: "Document is required",
  bac_partner_member_onboarding_upload_list_title: "Upload List",
  bac_partner_vehicle_onboarding_add_value_range_min_maximum_error: "Value must be valid and equal to or less than 9 digits",
  bac_partner_vehicle_onboarding_add_value_range_min_minimum_decimal_error_in_percentage: "Value range must not contain decimal points",
  bac_partner_vehicle_onboarding_add_value_range_min_positive_error: "Value range must be positive",
  bac_partner_vehicle_onboarding_update_bulk_status_error: "Please select at least one vehicle"
};
